import type { VehicleModelDetailsEntity } from '~/domain/Insurance/vehicleModelDetailsEntity';
import type { VehicleModelDetailsResponseDTO } from '~/dto/Insurance/vehicleModelDetailsDTO';

export const vehicleModelDetailsResponseMapper = ({
  success,
  resultData,
}: VehicleModelDetailsResponseDTO): VehicleModelDetailsEntity => {
  if (success && resultData.CodigoFipe) {
    return {
      success: true,
      fipeCode: resultData.CodigoFipe.trim(),
      fipeValue: resultData.Valor.trim(),
      modelDescription: resultData.Modelo,
      brandDescription: resultData.Marca,
    };
  }
  return {
    success: false,
    fipeCode: null,
    fipeValue: null,
    modelDescription: null,
    brandDescription: null,
  };
};
